import type { FaireProductEntity } from "../../entity_types/product";

export const p_bbun7rcy7w: FaireProductEntity = {
  token: "p_bbun7rcy7w",
  type: "product",
  name: "Boho Crochet Cover-Up Top",
  brandToken: "b_q6uy7uqavt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3409b02336b52469342f2b6691921e72b777e2ff61fcd24f4499008de6d85d28.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0cdf0ade3e6c60ebc58c908b954acd700dee81243c6594b19544390cd22f6c2.jpeg",
    "https://cdn.faire.com/fastly/25d1071ab31232d6209c33f786f30aed879fda799410454e7476c6d05bfcd797.jpeg",
    "https://cdn.faire.com/fastly/7fc37cb65c9579aae0bffda4f32d45004b5cd173b6d63296fcfcd0deb005d48e.jpeg",
    "https://cdn.faire.com/fastly/16eff26344db33b753fa0a1a4b3f23ca01d0f4f05e8eaab79f7c18ebb11b25c3.jpeg",
    "https://cdn.faire.com/fastly/0df8ca31c53ef5a55c4a56cc9c2d62b60af5c03070254afd9db4ec7c8b3e173e.jpeg",
    "https://cdn.faire.com/fastly/bda70a8dcf1bb12bacca7646723d3ec34aaa70aa687d3b65cc3fd4472957c2e6.jpeg",
    "https://cdn.faire.com/fastly/12907f2e9b6afc7fac254fcbfdac03ae9584d80c096c8f9b96d3fb50332ebf61.jpeg",
    "https://cdn.faire.com/fastly/f0e157d43ef6ed5964bd9ab4cef78b9c58cc8a615648447ab0726180d7915481.jpeg",
    "https://cdn.faire.com/fastly/0e1a03e1cb064f3ffe08485585b216c7c93be4cf454764dfc6bcb9f1f217c25c.jpeg",
    "https://cdn.faire.com/fastly/4cf8716e198d5bfd88990849c4f7ac7b5300a5c3418cffaee303603d65e24d31.jpeg",
  ],
  priceDollars: 13.42,
  description:
    "Intricate crochet, boho vibes, effortless chic—perfect for beachside elegance.\n\nFabric: 100% polyester\n\nWeight: 0.33 lb\n",
  tags: [],
  msrpDollars: 26.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:14.667Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
